<template>
    <y-modal
        ref="Modal"
        :title="$t('cart.panel.address.create')"
    >
        <div slot="body">
            <y-loading
                :active="$wait.is('loading-post')"
                height="200px"
            >
                <form
                    id="faq-form"
                    @submit.prevent="submit(save)"
                >
                    <y-form
                        v-model="model"
                        :params="form"
                    />
                </form>
            </y-loading>
        </div>

        <template
            v-if="!$wait.is('loading-post')"
            slot="footer"
        >
            <div class="ta-l w-100">
                <y-button
                    class="ml5"
                    @click.prevent.native="close"
                >
                    {{ $t('button.cancel') }}
                </y-button>
                <y-button
                    color="blue"
                    form="faq-form"
                    loading-on="submitting-form"
                >
                    {{ $t('button.save') }}
                </y-button>
            </div>
        </template>
    </y-modal>
</template>

<script>

    import FormMixin from '@/mixins/Form';
    import { YModal, YForm } from '@deps';

    export default {
        name: 'CreateAddressModal',

        components: {
            YModal,
            YForm,
        },

        mixins: [FormMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                id   : null,
                model: {},
                form : null,
            };
        },

        methods: {

            /**
             * Save form
             */
            fetch() {
                this.$wait.start('loading-post');
                const params = {
                    person_id: this.id,
                };
                return this.$services.Person.addressForm(params).then((response) => {
                    this.form = response.data.metadata.form;
                    this.model = response.data.results;
                }).catch((error) => {
                    this.close();
                    this.handleError(error);
                }).finally(() => this.$wait.end('loading-post'));
            },

            /**
             * Save form
             */
            save() {
                const params = {
                    ...this.model,
                    person_id: this.id,
                };
                return this.$services.Person.addressSaveByAdmin(params).then(() => {
                    this.$toast.success(this.$t('messages.save.success', { type: this.$t('cart.panel.address.name') }));
                    this.$emit('done');
                    this.close();
                }).catch((error) => {
                    this.handleError(error);
                });
            },

            /**
             * Open modal
             *
             * @param id
             */
            open(id) {
                this.id = id;
                this.fetch();
                this.$refs.Modal.open();
            },

            /**
             * Close modal
             */
            close() {
                this.$refs.Modal.close();
                this.reset();
            },

            /**
             * Reset modal data
             */
            reset() {
                this.id = null;
                this.form = null;
                this.model = {};
            },

        },
    };
</script>
